import { Stack, Typography } from '@mui/material';
import { DynamicIcon } from 'src/components';

interface MacroEmptyStateProps {
  isSearching: boolean;
}

export const MacroEmptyState = ({ isSearching }: MacroEmptyStateProps) => {
  return (
    <Stack alignItems="center" justifyContent="center" flex={1} padding={3}>
      <DynamicIcon name="bolt" />
      <Typography variant="subtitle1" marginTop={1}>
        {isSearching
          ? 'No macros match your search.'
          : 'No macros yet. Create one in manage mode.'}
      </Typography>
    </Stack>
  );
};
